<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
import {wx_share} from '../src/api/Interface'
import wx from 'weixin-js-sdk'
import {mapState} from 'vuex'

export default {
  name: "codes",
  data() {
    return {
      apiUrl: process.env.VUE_APP_BASE_API,
    }
  },
  mounted() {
    // this.share()
  },
  computed: {
    ...mapState(['settingData', 'formId'])
  },
  methods: {
    share() {
      let shareParam = {
        form_id: this.$store.state.formId,
        share_url: location.href.split('#')[0]
      }
      wx_share(shareParam).then(res => {
        if (res.state) {
          console.log(res);
          console.log(this.settingData)
          wx.config({
            debug: false,   // 代码调试的时候写true
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: [
              'onMenuShareTimeline',  // 分享给好友
              'onMenuShareAppMessage', // 分享到朋友圈
              'onMenuShareQQ',  // 分享到QQ
              'onMenuShareWeibo' // 分享到微博
            ]
          })
          wx.error(res => {
            console.log(res);
          })
          wx.ready(() => {
            // 分享到朋友圈
            wx.onMenuShareAppMessage({
              title: this.settingData.share.title,
              imgUrl: this.apiUrl + this.settingData.share.thumb,
              link: this.apiUrl + '/login?id=' + this.formId,
              desc: this.settingData.share.content,
              success: function () {
                // 用户确认分享后执行的回调函数

              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            })
            // 分享给好友
            wx.onMenuShareTimeline({
              title: this.settingData.share.title,
              imgUrl: this.apiUrl + this.settingData.share.thumb,
              link: this.apiUrl + '/login?id=' + this.formId,
              desc: this.settingData.share.content,
              success: function () {
                // 用户确认分享后执行的回调函数

              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            })
            // 分享到QQ
            wx.onMenuShareQQ({
              title: this.settingData.share.title,
              imgUrl: this.apiUrl + this.settingData.share.thumb,
              link: this.apiUrl + '/login?id=' + this.formId,
              desc: this.settingData.share.content,
              success: function () {
                // 用户确认分享后执行的回调函数

              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            })
            // 分享到微博
            wx.onMenuShareWeibo({
              title: this.settingData.share.title,
              imgUrl: this.apiUrl + this.settingData.share.thumb,
              link: this.apiUrl + '/login?id=' + this.formId,
              desc: this.settingData.share.content,
              success: function () {
                // 用户确认分享后执行的回调函数

              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            })
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
